import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const Deducibles = ({ deducibles }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab" className={`${open && "active"}`}>
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Deducibles"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th className="text-left">Item</th>
                                        <th className="text-left">Deducible</th>
                                        <th className={"text-right"}>Valor Fijo</th>
                                        <th className="text-left">Observaciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {deducibles.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={4}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {deducibles.map((item, index) => (
                                                <tr key={item.cdDeducible}>
                                                    <td className="text-left">
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left" style={{ maxWidth: 220 }}>
                                                        <span>{item.nmCobertura}</span>
                                                    </td>
                                                    <td className="text-left" style={{ maxWidth: 120 }}>
                                                        <span>
                                                            <ReactNumeric
                                                                valuex={item.valFijo ? item.valFijo : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </span>
                                                    </td>
                                                    <td className="text-left" style={{ maxWidth: 180 }}>
                                                        <span>{item.obsDeducible}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
